import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Exercise } from "../../../../models/Exercise";
import { SaleStep } from "../../../../store/stepSaleConfig/stepSaleConfigReducer";
import useEvents from "../../../EventSale/hooks/useEvents";
import EAProductBanner from "../../../shared/ProductBanner/EAProductBanner";
import EAAlert from "../../../shared/EAAlert";
import { replaceVariablesInString } from "../../OfferModules/replaceVariablesInString";
import useFacility from "../../../../../utils/hooks/useFacility";
import RecruitmentConfirmModal from "../RecruitmentConfirmModal";

interface IProps {
  item: Exercise;
  saleStep: SaleStep;
  highlightedFeatures?: string[];
}

const SingleRecruitment: React.FC<IProps> = ({ item, saleStep, highlightedFeatures }) => {
  const { t } = useTranslation();
  const facilityIds = useFacility();
  const { getTicketsForEvent, tickets, formatTicketAccess } = useEvents();
  const [ticketsLoaded, setTicketsLoaded] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const loadTickets = async () => {
      await formatTicketAccess(item);
      await getTicketsForEvent(item.exerciseGroup.objectDb, item.exerciseGroup.objectId);
      setTicketsLoaded(true);
    };
    loadTickets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item.objectId]);

  const hasTickets = tickets.length > 0;
  const buttonTitle = saleStep.buttonCustomTitle || t("zloz_rezerwacje");

  return (
    <>
      <EAProductBanner
        title={item.name}
        pictureUrl={item.eventMessage}
        description={item.description}
        mainPrice=""
        buttonTitle={buttonTitle}
        onClick={() => setIsModalOpen(true)}
        highlightBanner={saleStep.highlightBanner}
        bannerLabel={replaceVariablesInString(saleStep.bannerLabel ? saleStep.bannerLabel : "", item)}
        highlightedFeatures={highlightedFeatures}
        loginRequired={saleStep.loginRequired}
        hidePrice
        buttonDisabled={ticketsLoaded && !hasTickets}
      />

      {ticketsLoaded && !hasTickets && (
        <EAAlert type="error" message={t("wszystkie_bilety_zostaly_sprzedane")} />
      )}

      {isModalOpen && hasTickets && (
        <RecruitmentConfirmModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          item={item}
          tickets={tickets}
          saleStep={saleStep}
          facilityIds={facilityIds}
        />
      )}
    </>
  );
};

export default SingleRecruitment;
